export default "__VITE_ASSET__a950c4a0__"